import type { ITechOperationDto } from "../shared/dtos/tech-operation.dto";
import { TechOperation } from "../shared/models/tech-operation";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function isPagedResponse(value: unknown): value is { data: unknown[] } {
  return isRecord(value) && Array.isArray(value.data);
}

function isTechOperationDto(value: unknown): value is ITechOperationDto {
  return isRecord(value) && typeof value.id === "string";
}

export function getTechOperationFromPagedResponse(
  response: unknown
): TechOperation | undefined {
  if (!isPagedResponse(response)) {
    return undefined;
  }

  const techOperationDto = response.data[0];
  if (!isTechOperationDto(techOperationDto)) {
    return undefined;
  }

  return TechOperation.fromDto(techOperationDto);
}
